import api, { request } from '../../../api';
import { IStore } from '../../index';

const getRoundTees = async (_: IStore, clubId: number, eventId: number, roundId: number) => {
  const response = await request.get(api.roundTees(clubId, eventId, roundId));

  if (response.error) {
    return { errors: { seasons: { msg: 'Error fetching round tees' } } };
  }

  return { roundTees: { assignation: response } };
};

export default getRoundTees;
